const AWSCognitoPoolData = {
  UserPoolId: process.env.REACT_APP_AWS_COGNITO_POOL,
  ClientId: process.env.REACT_APP_AWS_COGNITO_CLIENT,
};
export { AWSCognitoPoolData };
